import type { ComponentType } from 'react';
import styled from 'styled-components';
import { iconByRatingStyle } from '@frameio/assets/fields';
import type { RatingStyleEnum } from '@frameio/graphql-client/generated';
import { theme } from '@frameio/vapor';
import type { ThemeColorsMetaIcon } from '@frameio/vapor-theme';

type RatingFieldMatchProps = {
  /** The color of filled icons */
  color?: ThemeColorsMetaIcon;
  /** The maximum number of icons */
  maxValue?: number;
  /** The rating style (STAR, HEART, THUMBS_UP) */
  style?: RatingStyleEnum;
  /** The current rating value */
  rating?: number;
};

export const RatingFieldMatch = ({
  color = 'yellow',
  maxValue = 5,
  style = 'STAR',
  rating = 0,
}: RatingFieldMatchProps) => {
  const icons = iconByRatingStyle[style];

  return (
    <RatingContainer>
      {[...Array(maxValue)].map((_, index) => {
        const iconValue = index + 1;
        const isFilled = rating ? rating >= iconValue : false;
        const IconComponent = icons.Icon as ComponentType<{ size: number }>;

        return (
          <RatingIcon key={iconValue} $color={color} $filled={isFilled}>
            <IconComponent size={16} />
          </RatingIcon>
        );
      })}
    </RatingContainer>
  );
};

const RatingContainer = styled.div`
  align-items: center;
  display: inline-flex;
  gap: 1px;
  height: 24px;
`;

type RatingIconProps = {
  $filled: boolean;
  $color: ThemeColorsMetaIcon;
};

const RatingIcon = styled.div<RatingIconProps>`
  align-items: center;
  color: ${(p) =>
    p.$filled
      ? theme.colors.meta.icon[p.$color]
      : theme.colors.icon.interactive.off};
  display: inline-flex;
  justify-content: center;
`;
